module.exports = __webpack_public_path__ + "img/lt.11b8661d.svg";